module.exports = __webpack_public_path__ + "img/logo.62b639c9.svg";